import { useState } from 'react';
import { useUser } from '../contexts/UserContext';

export const useVerification = () => {
  const { verified } = useUser();
  const [showVerifyModal, setShowVerifyModal] = useState(false);

  const requireVerified = () => {
    if (verified) return true;
    setShowVerifyModal(true);
    return false;
  };

  return { verified, showVerifyModal, setShowVerifyModal, requireVerified };
};
